export const getDictionaryEntry = (
  entry: string | undefined,
  fallback: string,
): string => {
  if (entry === undefined || entry.length === 0) {
    // Check if the entry is empty or undefined
    return fallback;
  }
  return entry;
};
